module.exports = __webpack_public_path__ + "img/offline.4cd757dd.svg";